export default {
    props: [
        'hasPdo',
        'pdoConfig',
        'birthdayOffer',
    ],

    data() {
        return {
            firstPaymentOffer: null,
            extraPaymentOffer: null
        }
    },

    computed: {
        /**
         * @returns {boolean}
         */
        hasPdoOffers() {
            if (! this.offers.length) return false;

            return !! this.offers.filter(offer => offer.hasOwnProperty('can_be_deferred') && offer.can_be_deferred).length;
        }
    },

    watch: {
        firstPaymentOffer(val, oldVal) {
            if (val !== null && val && oldVal === null && this.data.deals.pdoAccepted === null) {
                this.gtagEvent(`pdo-accepted:${this.pageForEvents}`);
            } else if (val !== null && ! val && oldVal === null && this.data.deals.pdoAccepted === null) {
                this.gtagEvent(`pdo-declined:${this.pageForEvents}`);
            }
        },

        'data.deals.pdoAccepted'(val, oldVal) {
            if (val && ! oldVal) {
                this.firstPaymentOffer = true;

                this.gtagEvent(`pdo-accepted-popup:${this.pageForEvents}`);
            } else if (! val && ! oldVal) {
                this.firstPaymentOffer = false;

                this.gtagEvent(`pdo-declined-popup:${this.pageForEvents}`);

                setTimeout(() => {
                    this.$root.$refs.app.showingOverlay.pdoExtra = true;
                }, 1000); // Slight delay to make sure previous modal closed entirely...
            }
        },

        'data.deals.pdoExtraAccepted'(val, oldVal) {
            if (val && ! oldVal) {
                this.extraPaymentOffer = true;

                this.getOffers();

                this.gtagEvent(`pdo-extra-accepted:${this.pageForEvents}`);
            } else if (! val && ! oldVal) {
                this.extraPaymentOffer = false;

                this.gtagEvent(`pdo-extra-declined:${this.pageForEvents}`);
            }
        }
    },

    methods: {
        setOfferTimeouts() {
            if (this.$parent.settings.consumer_portal_pdo_popup_delay) {
                setTimeout(() => {
                    if (this.hasPdo && this.hasPdoOffers && this.firstPaymentOffer === null && this.selectedOffer === null) {
                        this.$root.$refs.app.showingModal.pdo = true;
                    }
                }, this.$parent.settings.consumer_portal_pdo_popup_delay * 1000);
            }

            if (this.birthdayOffer && this.$parent.settings.consumer_portal_birthday_offer) {
                setTimeout(() => {
                    this.$root.$refs.app.showingModal.birthday = true;
                }, 2000);
            }
        },

        /**
         * @returns {void}
         */
        declinePdoBanner() {
            this.firstPaymentOffer = false;

            setTimeout(() => this.$root.$refs.app.showingOverlay.pdoExtra = true, 750);
        },
    }
}